import React from "react";
import { Input } from "semantic-ui-react";

function InputField({ objData, objFieldName, onChange, ...props }) {
  return (
    <Input
      value={objData[objFieldName]}
      onChange={(sb, { value }) => onChange({ fieldName: objFieldName, value })}
      {...props}
    />
  );
}

export default InputField;
